import { render } from "./add.svg?vue&type=template&id=08d86de6"
const script = {}
script.render = render

export default script